import { render, staticRenderFns } from "./securitygroups.vue?vue&type=template&id=67a79187&"
import script from "./securitygroups.vue?vue&type=script&lang=js&"
export * from "./securitygroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports